import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { gql } from "@apollo/client";
import { apolloClient } from "../../services/apolloclient";
import "../../styles/common.css";
import "./Html.css";

const GET_SCHEMA = gql`
  query MyQuery {
    __schema {
      queryType {
        fields {
          name
        }
      }
    }
  }
`;

const Html = () => {
  const [searchParams] = useSearchParams();
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);

  const tab = searchParams.get("tab");

  useEffect(() => {
    let isMounted = true;
    window.scrollTo({ top: 0, behavior: "instant" });

    const loadContent = async () => {
      try {
        setLoading(true);

        const schemaResult = await apolloClient.query({
          query: GET_SCHEMA,
          fetchPolicy: "network-only",
        });

        const allFields = schemaResult.data?.__schema?.queryType?.fields || [];
        const queryName = allFields.find((item) => {
          const lower = item.name.toLowerCase();
          return lower === tab?.toLowerCase() || lower.includes(tab?.toLowerCase());
        })?.name;

        if (!queryName) {
          throw new Error(`No CMS content type found for tab: '${tab}'`);
        }

        const CONTENT_QUERY = gql`
          query MyQuery {
            ${queryName} {
              title {
                titlepart
              }
              htmlBody {
                html
              }
            }
          }
        `;

        const result = await apolloClient.query({
          query: CONTENT_QUERY,
          fetchPolicy: "network-only",
        });

        const cmsContent = result.data?.[queryName];
        if (isMounted) setContent(Array.isArray(cmsContent) ? cmsContent[0] : cmsContent);

      } catch (error) {
        console.error("Error loading content:", error);
        if (isMounted) setContent(null);
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    if (tab) {
      loadContent();
    } else {
      setLoading(false);
    }

    return () => { isMounted = false; };
  }, [tab]);

  if (loading) {
    return <div className="html-page">Loading...</div>;
  }

  if (!content) {
    return (
      <main className="html-page">
        <div className="html-content">
          <p>Content not available.</p>
        </div>
      </main>
    );
  }

  return (
    <main className="html-page">
      <div className="html-content">
         <h1>{content?.title?.titlepart}</h1>
        <div dangerouslySetInnerHTML={{ __html: content?.htmlBody?.html || "" }} />
      </div>
    </main>
  );
};

export default Html;
